<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="700px"
    v-model="calculatorModel"
    v-bind:content-class="calculatorClass"
    scrollable
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card
      class="text-center ma-0 pa-0"
      v-bind:class="
        $vuetify.breakpoint.xsOnly ? '' : 'calculator-dialog-height'
      "
    >
      <v-card-title class="ma-0 pa-0">
        <v-col cols="12" class="ma-0 pa-0">
          <vetalfa-small-header
            :backMethod="
              () => {
                calculatorModel = false;
              }
            "
            isNavigationDialog
            :title="_getLabel('CALCULATORS')"
            closable
            class="vetalfa-padding-top-notch"
          ></vetalfa-small-header>
          <v-row class="ma-0 pa-0">
            <v-tabs
              v-model="tabModel"
              background-color="transparent"
              color="#193153 !important"
              centered
              height="50px"
              class="mt-2 pa-0"
              fixed-tabs
            >
              <v-tab
                class="text-none pa-0"
                v-for="tab in calculatorLabels.CALCULATORS_HEADERS"
                :key="tab.name"
                @click="
                  $vuetify.goTo(0, {
                    duration: 0,
                    offset: 0,
                    easing: 'easeInOutCubic',
                  })
                "
              >
                <span class="">{{ tab.name }}</span>
              </v-tab>
            </v-tabs>
          </v-row>
          <v-divider></v-divider>
        </v-col>
      </v-card-title>
      <v-card-text class="ma-0 pa-0">
        <v-tabs-items v-model="tabModel" class="ma-0 pa-0" style="width: 100%">
          <v-tab-item v-show="tabModel == 0">
            <v-sheet class="text-center">
              <v-row aling="center" justify="center" class="pa-2 ma-0 mt-5">
                <v-row
                  class="ma-0 pa-0"
                  aling="center"
                  justify="center"
                  style="max-width: 768px !important"
                >
                  <v-col
                    cols="12"
                    align-self="end"
                    class="pa-2 ma-0 mb-5 headline"
                  >
                    <span>{{ result }}</span>
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="clearClick()"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-2
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      dark
                      rounded
                      block
                      x-large
                      >C</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="invertClick()"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-2
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      dark
                      rounded
                      block
                      x-large
                      >+/-</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="percentageClick()"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-2
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      dark
                      rounded
                      block
                      x-large
                      >%</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="operatorClick(4)"
                      class="ma-0 pa-0"
                      dark
                      rounded
                      block
                      x-large
                      v-bind:class="
                        stackOperator == 4
                          ? 'primary black--text background-disable-dbl-tap-zoom'
                          : 'primary background-disable-dbl-tap-zoom'
                      "
                      >÷</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num7)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num7 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num8)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num8 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num9)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num9 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="operatorClick(3)"
                      class="ma-0 pa-0 text-none"
                      v-bind:class="
                        stackOperator == 3
                          ? 'primary black--text background-disable-dbl-tap-zoom'
                          : 'primary background-disable-dbl-tap-zoom'
                      "
                      dark
                      rounded
                      block
                      x-large
                      >x</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num4)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num4 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num5)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num5 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num6)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num6 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="operatorClick(2)"
                      v-bind:class="
                        stackOperator == 2
                          ? 'primary black--text background-disable-dbl-tap-zoom'
                          : 'primary background-disable-dbl-tap-zoom'
                      "
                      class="ma-0 pa-0 primary"
                      dark
                      rounded
                      block
                      x-large
                      >-</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num1)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num1 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num2)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num2 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="numberClick(num3)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num3 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0">
                    <v-btn
                      @click="operatorClick(1)"
                      v-bind:class="
                        stackOperator == 1
                          ? 'primary black--text background-disable-dbl-tap-zoom'
                          : 'primary background-disable-dbl-tap-zoom'
                      "
                      class="ma-0 pa-0"
                      dark
                      rounded
                      block
                      x-large
                      >+</v-btn
                    >
                  </v-col>
                  <v-col cols="6" class="pa-2 ma-0 mb-5">
                    <v-btn
                      @click="numberClick(num0)"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >{{ num0 }}</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0 mb-5">
                    <v-btn
                      @click="addComma()"
                      class="
                        ma-0
                        pa-0
                        grey
                        lighten-5
                        primary--text
                        background-disable-dbl-tap-zoom
                      "
                      rounded
                      block
                      x-large
                      >,</v-btn
                    >
                  </v-col>
                  <v-col cols="3" class="pa-2 ma-0 mb-5">
                    <v-btn
                      @click="calculate()"
                      class="ma-0 pa-0 primary"
                      dark
                      rounded
                      block
                      x-large
                      >=</v-btn
                    >
                  </v-col>
                </v-row>
              </v-row>
            </v-sheet>
          </v-tab-item>
          <v-tab-item v-show="tabModel == 1">
            <dose-calculator componentMode></dose-calculator>
          </v-tab-item>
          <v-tab-item v-show="tabModel == 2">
            <rule-of-three-calculator componentMode></rule-of-three-calculator>
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<style scoped>
.background-disable-dbl-tap-zoom {
  touch-action: manipulation !important;
}
.calculator-dialog-height {
  height: 600px;
}
</style>

<script>
import {} from "@mdi/js";
import labels from "@/constants/labels.js";
import calculatorLabels from "@/constants/labels/calculators.labels.js";
import DoseCalculator from "@/views/DoseCalculator.vue";
import RuleOfThreeCalculator from "@/views/RuleOfThreeCalculator.vue";
import { mapGetters, mapMutations, mapActions } from "vuex";
export default {
  name: "Calculator",
  props: {},
  components: {
    "dose-calculator": DoseCalculator,
    "rule-of-three-calculator": RuleOfThreeCalculator,
  },
  watch: {
    tabModel(val) {
      this.logEvent({ name: "calculatorTabClick", object: { id: val } });
      if (val != 0) {
        this.setCalculator(
          {
            1: this.calculatorLabels.DOSE_CALCULATOR_ID,
            2: this.calculatorLabels.RULE_OF_THREE_ID,
          }[val]
        );
      }
    },
  },
  methods: {
    ...mapMutations("general", ["setCalculatorModel"]),
    ...mapActions("calculators", ["setCalculator"]),
    ...mapActions("general", ["logEvent"]),
    addComma() {
      if (!this.result.includes(",")) {
        this.result += ",";
      }
    },
    clearClick() {
      this.result = "0";
      this.stackOperator = 0;
      this.stackValue = null;
      this.hasCleanedResult = true;
    },
    invertClick() {
      let number = Number(this.result.replace(",", "."));
      this.result = (number * -1).toString().replace(".", ",");
    },
    operatorClick(operator) {
      this.hasCleanedResult = false;
      if (this.stackValue && this.stackOperator) {
        this.calculate();
      }
      this.stackOperator = operator;
      this.stackValue = Number(this.result.replace(",", "."));
    },
    numberClick(number) {
      if (!this.hasCleanedResult) {
        this.result = "0";
        this.hasCleanedResult = true;
      }
      if (this.result == "0") {
        this.result = number.toString();
      } else {
        this.result += number.toString();
      }
    },
    percentageClick() {
      if (this.stackValue != null) {
        let value = 0;
        switch (this.stackOperator) {
          case 1:
            value =
              this.stackValue +
              (this.stackValue * Number(this.result.replace(",", "."))) / 100;
            break;
          case 2:
            value =
              this.stackValue -
              (this.stackValue * Number(this.result.replace(",", "."))) / 100;
            break;
          case 3:
            value =
              (this.stackValue * Number(this.result.replace(",", "."))) / 100;
            break;
          case 4:
            value =
              this.stackValue / (Number(this.result.replace(",", ".")) / 100);
            break;
        }
        this.stackValue = value;
        this.result = value.toString().replace(".", ",");
        this.stackOperator = 0;
      } else {
        this.result = (Number(this.result.replace(",", ".")) / 100)
          .toString()
          .replace(".", ",");
      }
    },
    calculate() {
      let value = 0;
      if (this.stackValue != null) {
        switch (this.stackOperator) {
          case 1:
            value = this.stackValue + Number(this.result.replace(",", "."));
            break;
          case 2:
            value = this.stackValue - Number(this.result.replace(",", "."));
            break;
          case 3:
            value = this.stackValue * Number(this.result.replace(",", "."));
            break;
          case 4:
            value = this.stackValue / Number(this.result.replace(",", "."));
            break;
        }
        this.stackValue = value;
        this.result = value.toString().replace(".", ",");
        this.stackOperator = 0;
      }
    },
  },
  computed: {
    ...mapGetters("general", ["getCalculatorModel"]),
    calculatorModel: {
      get() {
        return this.getCalculatorModel;
      },
      set(calculatorModel) {
        this.setCalculatorModel(calculatorModel);
      },
    },
    sheetHeight() {
      return window.innerHeight;
    },
    calculatorClass() {
      return this.$vuetify.breakpoint.xsOnly ? "v-bottom-sheet" : "";
    },
  },
  data() {
    return {
      labels,
      tabModel: 0,
      calculatorLabels,
      result: "0",
      num0: 0,
      num1: 1,
      num2: 2,
      num3: 3,
      num4: 4,
      num5: 5,
      num6: 6,
      num7: 7,
      num8: 8,
      num9: 9,
      stackValue: null,
      stackOperator: 0,
      hasCleanedResult: true,
    };
  },
};
</script>